import React from 'react';
import { Tag, Popover, Descriptions } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import theme from 'shared/constants/theme.json';
import SettingLabel from 'components/Settings/SettingLabel';
import useDataSource from 'hooks/useDataSource';
import { FormattedNumber } from 'react-intl';
import { SURVEY_LIMIT_TYPES } from 'shared/constants/settings';

const LicenseTag = ({ dataSourceId, activeLicense, setting, extra, showTooltip, popoverProps }) => {
  const { dataSource } = useDataSource({ dataSourceId });
  const tag = (
    <Tag icon={<LockOutlined />} color={theme['error-color']}>
      License
    </Tag>
  );

  if (!activeLicense) {
    activeLicense = dataSource?.activeLicense;
  }

  if (showTooltip) {
    // Let surveyLimit override the other survey limits
    if (SURVEY_LIMIT_TYPES[setting] && activeLicense?.settings?.surveyLimit != null) {
      setting = 'surveyLimit';
    }

    let settingValue = activeLicense?.settings?.[setting];

    if (settingValue === -1) {
      settingValue = <em>Unlimited</em>;
    } else if (Number.isInteger(settingValue)) {
      settingValue = <FormattedNumber value={settingValue} />;
    }

    return (
      <Popover
        title="This is limited by your license"
        content={(
          <Descriptions bordered column={1} size="small">
            {dataSource && <Descriptions.Item label="Data source">{dataSource.title}</Descriptions.Item>}
            {activeLicense?.license?.title && <Descriptions.Item label="Current license">{activeLicense.license.title}</Descriptions.Item>}
            {setting && <Descriptions.Item label="Feature"><SettingLabel setting={setting} /></Descriptions.Item>}
            {settingValue && <Descriptions.Item label="Limit">{settingValue}</Descriptions.Item>}
            {extra && extra.map(({ label, value }) => <Descriptions.Item key={label} label={label}>{value}</Descriptions.Item>)}
          </Descriptions>
    )}
        {...popoverProps}
      >
        {tag}
      </Popover>
    );
  }

  return tag;
};

export default LicenseTag;
